import Card from "react-bootstrap/Card";
import CardImg from "react-bootstrap/CardImg";
import React from "react";
import "./ViewOptionCard.css";

type ViewOptionCardProps = {
  title: string;
  icon: string;
  onClick: (event: React.MouseEvent<any>) => void;
};

function ViewOptionCard({ title, icon, onClick }: ViewOptionCardProps) {
  return (
    <Card className="mr-4 w-360px mb-4 clickable" onClick={onClick}>
      <CardImg variant="top" src={icon} className="mx-auto py-2 card-image" />
      <Card.Body className={"my-2"}>
        <Card.Title bsPrefix={"card-title"}>
          <h4>{title}</h4>
        </Card.Title>
      </Card.Body>
    </Card>
  );
}

export default ViewOptionCard;
